import React from 'react'
import { Box, Typography } from '@mui/material'
import { onDark } from '../theme'

type Props = {
  title: string
  action?: React.ReactNode
  children: React.ReactNode
  /** Sit inside a shared card instead of drawing one. */
  grouped?: boolean
  /** Hairline above this group, for every group after the first. */
  divided?: boolean
}

// The raised card the drawer's scrolling sections sit on.
export const drawerCardSx = {
  borderRadius: 1,
  border: `1px solid ${onDark.line}`,
  backgroundColor: onDark.surface,
  overflow: 'hidden',
}

const Section = ({ title, action, children, grouped = false, divided = false }: Props) => (
  <Box
    component="section"
    sx={grouped ? { ...(divided ? { borderTop: `1px solid ${onDark.line}` } : undefined) } : drawerCardSx}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: 2,
        minHeight: 40,
        borderBottom: `1px solid ${onDark.line}`,
      }}
    >
      <Typography
        component="h2"
        variant="caption"
        sx={{ color: onDark.primary, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}
      >
        {title}
      </Typography>
      {action}
    </Box>
    <Box sx={{ px: 2, py: 1.5 }}>{children}</Box>
  </Box>
)

export default Section
